import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface SearchButtonHandlingState {
  searchButtonClicked: boolean;
}

const initialState: SearchButtonHandlingState = {
  searchButtonClicked: true,
};

const searchButtonHandlingSlice = createSlice({
  name: 'searchButtonHandling',
  initialState,
  reducers: {
    setSearchButtonClicked: (state, action: PayloadAction<boolean>) => {
      state.searchButtonClicked = action.payload;
    },
  },
});

export const { setSearchButtonClicked } = searchButtonHandlingSlice.actions;
export default searchButtonHandlingSlice.reducer;
